define([
  "app/modules/employmentHistory/item",
  "app/modules/utilities",
  "rangeslider.js"
], function(EmploytmentHistoryItem, Util) {
  class EmploytmentHistory {
    constructor({ $container = $(document), resourceName }) {
      this.$el = $container.find(".js-employment-history");
      this.resourceName = resourceName;

      this.updatePlugins = this.updatePlugins.bind(this);

      this.init();
      this.bindEvents();
    }

    init() {
      this.$el.each(
        (i, el) =>
          new EmploytmentHistoryItem({ el, resourceName: this.resourceName })
      );
    }

    bindEvents() {
      $(document).on("nested:fieldAdded", this.updatePlugins);
      $(document).on("interests:update", this.updatePlugins);
    }

    updatePlugins(event, field) {
      const $field = event.field || $(field);
      const $employmentHistory = $field.find(".js-employment-history");
      const $checkbox = $field.find(":checkbox")

      if ($employmentHistory.length) {
        new EmploytmentHistoryItem({
          el: $employmentHistory,
          resourceName: this.resourceName
        });
      }

      $field.find(".chosen-select-with-search").chosen({
        disable_search_threshold: 10,
        width: "100%",
        allow_single_deselect: true
      });

      $checkbox.iCheck({ handle: "checkbox" });

      Util.datepickerMonth();
      Util.datepickerYearMonth();
      Util.datepickerYearMonthDay();
    }
  }

  return EmploytmentHistory;
});
